import PizzaFeature from "@/components/sections/PizzaFeature";
import FinalCTA from "@/components/sections/FinalCTA";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { IMG } from "@/data/content";

const FEATURES = [
  "Elastic și ușor de lucrat în bucătăriile aglomerate",
  "Aspect echilibrat după coacere, cu marginile aurii",
  "Gust constant la fiecare lot, fără surprize",
  "Format congelat 250g pentru porționare predictibilă",
  "Ideal pentru pizzerii, fast-food și restaurante",
];

export default function BlatPizza() {
  return (
    <div data-testid="page-blat-pizza">
      <PizzaFeature />
      <section className="section-pad">
        <div className="max-w-7xl mx-auto container-px grid lg:grid-cols-12 gap-12 items-start">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="lg:col-span-6">
            <p className="eyebrow">Detalii produs</p>
            <h2 className="h-display text-3xl md:text-5xl text-text mt-4">De ce blatul DOTAPAN.</h2>
            <ul className="mt-8 space-y-4">
              {FEATURES.map((f, i) => (
                <li key={i} className="flex items-start gap-3 text-base text-text-soft">
                  <span className="h-6 w-6 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                    <Check className="h-3.5 w-3.5 text-gold" />
                  </span>
                  {f}
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="lg:col-span-6">
            <div className="relative rounded-3xl overflow-hidden border border-border">
              <img src={IMG.pizzaDough} alt="Blat pizza DOTAPAN" className="w-full h-[520px] object-cover" />
            </div>
          </motion.div>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
}
